import ReleaseIndex from '../components/Release/Index'
import ReleaseStep1 from '../components/Release/Step1/Index'
import ReleaseStep2 from '../components/Release/Step2/Index'
import ReleaseStep2Jacket from '../components/Release/Step2/Jacket'
import ReleaseStep2Product from '../components/Release/Step2/Product'
import ReleaseStep2Track from '../components/Release/Step2/Track'
import ReleaseStep3 from '../components/Release/Step3/Index'
import ReleaseStep5 from '../components/Release/Step5/Index'
import ReleaseCreate from '../components/Release/Create'
import ReleaseCompleted from '../components/Release/Completed'
import Submit from '../components/Release/Step3/Submit'
import SubmitCompleted from '../components/Release/SubmitCompleted'
import SubmitCanceled from '../components/Release/SubmitCanceled'

export default [
  // マイリリース
  {
    path: '/client/release/',
    name: 'release-index',
    component: ReleaseIndex,
    meta: {
      sideMenuId: 'my-release',
    },
  },
  // シングル遷移
  {
    path: '/client/release/single',
    name: 'release-single',
    props: {
      type: 'single',
    },
    component: ReleaseCreate,
  },
  {
    path: '/client/release-single/step1',
    name: 'release-single-step1',
    component: ReleaseStep1,
    meta: {
      sideMenuId: 'release-single',
    },
  },
  {
    path: '/client/release/detail',
    name: 'release-detail',
    component: ReleaseStep2,
    meta: {
      sideMenuId: 'my-release',
    },
  },
  {
    path: '/client/release-single/step2',
    name: 'release-single-step2',
    component: ReleaseStep2,
    meta: {
      sideMenuId: 'release-single',
    },
  },
  {
    path: '/client/release-single/step2/jacket',
    name: 'release-single-step2-jacket',
    component: ReleaseStep2Jacket,
    meta: {
      sideMenuId: 'release-single',
    },
  },
  {
    path: '/client/release-single/step2/product',
    name: 'release-single-step2-product',
    component: ReleaseStep2Product,
    meta: {
      sideMenuId: 'release-single',
    },
  },
  {
    path: '/client/release-single/step2/track/:discIndex/:trackIndex',
    name: 'release-single-step2-track',
    component: ReleaseStep2Track,
    meta: {
      sideMenuId: 'release-single',
    },
  },
  {
    path: '/client/release-single/step3',
    name: 'release-single-step3',
    component: ReleaseStep3,
    meta: {
      sideMenuId: 'release-single',
    },
  },
  {
    path: '/client/release-single/step5',
    name: 'release-single-step5',
    component: ReleaseStep5,
    meta: {
      sideMenuId: 'release-single',
    },
  },
  {
    path: '/client/release-single/submit',
    name: 'release-single-submit',
    component: Submit,
    meta: {
      sideMenuId: 'release-single',
    },
  },
  {
    path: '/client/release-single/completed',
    name: 'release-single-completed',
    component: ReleaseCompleted,
    meta: {
      sideMenuId: 'release-single',
    },
  },
  {
    path: '/client/release-single/submit-completed',
    name: 'release-single-submit-completed',
    component: SubmitCompleted,
    meta: {
      sideMenuId: 'release-single',
    },
  },
  {
    path: '/client/release-single/submit-canceled',
    name: 'release-single-submit-canceled',
    component: SubmitCanceled,
    meta: {
      sideMenuId: 'release-single',
    },
  },
  // アルバム遷移
  {
    path: '/client/release/album',
    name: 'release-album',
    props: {
      type: 'album',
    },
    component: ReleaseCreate,
  },
  {
    path: '/client/release-album/step1',
    name: 'release-album-step1',
    component: ReleaseStep1,
    meta: {
      sideMenuId: 'release-album',
    },
  },
  {
    path: '/client/release-album/step2',
    name: 'release-album-step2',
    component: ReleaseStep2,
    meta: {
      sideMenuId: 'release-album',
    },
  },
  {
    path: '/client/release-album/step2/jacket',
    name: 'release-album-step2-jacket',
    component: ReleaseStep2Jacket,
    meta: {
      sideMenuId: 'release-album',
    },
  },
  {
    path: '/client/release-album/step2/product',
    name: 'release-album-step2-product',
    component: ReleaseStep2Product,
    meta: {
      sideMenuId: 'release-album',
    },
  },
  {
    path: '/client/release-album/step2/track/:discIndex/:trackIndex',
    name: 'release-album-step2-track',
    component: ReleaseStep2Track,
    meta: {
      sideMenuId: 'release-album',
    },
  },
  {
    path: '/client/release-album/step3',
    name: 'release-album-step3',
    component: ReleaseStep3,
    meta: {
      sideMenuId: 'release-album',
    },
  },
  {
    path: '/client/release-album/step5',
    name: 'release-album-step5',
    component: ReleaseStep5,
    meta: {
      sideMenuId: 'release-album',
    },
  },
  {
    path: '/client/release-album/submit',
    name: 'release-album-submit',
    component: Submit,
    meta: {
      sideMenuId: 'release-album',
    },
  },
  {
    path: '/client/release-album/completed',
    name: 'release-album-completed',
    component: ReleaseCompleted,
    meta: {
      sideMenuId: 'release-album',
    },
  },
  {
    path: '/client/release-album/submit-completed',
    name: 'release-album-submit-completed',
    component: SubmitCompleted,
    meta: {
      sideMenuId: 'release-album',
    },
  },
  {
    path: '/client/release-album/submit-canceled',
    name: 'release-album-submit-canceled',
    component: SubmitCanceled,
    meta: {
      sideMenuId: 'release-album',
    },
  },

  // ストア再設定
  {
    path: '/client/my-release-single/step3',
    name: 'my-release-single-step3',
    component: ReleaseStep3,
    meta: {
      sideMenuId: 'release-single',
    },
    props: {
      resetting: true,
    },
  },
  {
    path: '/client/my-release-single/completed',
    name: 'my-release-single-completed',
    component: ReleaseCompleted,
    meta: {
      sideMenuId: 'release-single',
    },
    props: {
      resetting: true,
    },
  },
  {
    path: '/client/my-release-album/step3',
    name: 'my-release-album-step3',
    component: ReleaseStep3,
    meta: {
      sideMenuId: 'release-album',
    },
    props: {
      resetting: true,
    },
  },
  {
    path: '/client/my-release-album/completed',
    name: 'my-release-album-completed',
    component: ReleaseCompleted,
    meta: {
      sideMenuId: 'release-album',
    },
    props: {
      resetting: true,
    },
  },
]
